import { render, staticRenderFns } from "./BoatFieldset.vue?vue&type=template&id=0f8b1956&scoped=true"
import script from "./BoatFieldset.vue?vue&type=script&lang=js"
export * from "./BoatFieldset.vue?vue&type=script&lang=js"
import style0 from "./BoatFieldset.vue?vue&type=style&index=0&id=0f8b1956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8b1956",
  null
  
)

export default component.exports